import { AboutusHero } from "@modules/study/aboutus";
import CountdownTwo from "@modules/study/common/sections/countdown_two";
import { LayoutMain } from "@unisearch/theme/layout";

const WhoWeAre = () => {
  return (
    <LayoutMain
      title="About Us"
      metaUrl={`${process.env.NEXT_PUBLIC_URL}/who-we-are`}
    >
      <AboutusHero />
      <CountdownTwo isPaddingBig={true} />
    </LayoutMain>
  );
};

export default WhoWeAre;
